export type PromotionQualifier = 'free-round' | 'awarded-feature';